<template>
    <div class="wizard-step">
        <div class="wizard-step__inner">
            <div class="wizard-step-head wizard-step-head_full pt-0 mb-24">
                <div class="wizard-step-head__inner">
                    <div class="container">
                        <el-row :gutter="12" type="flex" align="middle">

                          <el-col>
                            <button class="btn btn_primary" @click="openQualificationsDialog(null)"> Добавить профессиональную квалификацию </button>
                          </el-col>

                            <el-col :span="6" :offset="4" class="wizard-step-head__grow" v-show="!IS_PANEL_OPEN">
                                <div class="wizard-step-head__extra">
                                    <v-select class="select" placeholder="Группировка" :value="groupItemsBy.label" :clearable="false" :options="groupQualificationsOpts" :disabled="!groupQualifications.length" @input="setItemsGroup">
                                        <template #no-options="{ search, searching, loading }">
                                            {{ SELECT_NOT_FOUND }}
                                        </template>
                                        <template #open-indicator="{ attributes }">
                                            <span v-bind="attributes">
                                                <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                                            </span>
                                        </template>
                                    </v-select>
                                </div>
                            </el-col>

                            <el-col :span="!IS_PANEL_OPEN ? 8 : 24">
                                <div class="wizard-step-head__extra">
                                    <form
                                        class="search-form wizard-step-head__grow"
                                        @submit.prevent
                                    >
                                        <div class="search-form__inner">
                                            <input type="search" class="input search-form__input" :class="{ 'search-form__input_reset': searchInput && searchInput.length !== 0 }" placeholder="Поиск" :disabled="!qualifications.length" v-model.trim="searchInput" @keydown.enter.prevent.stop>

                                            <button v-if="searchInput && searchInput.length !== 0" class="search-form__reset" @click="searchInput = ''">
                                                <icon-base viewBox="0 0 14 14"><icon-cancel /></icon-base>
                                            </button>

                                            <button type="submit" class="search-form__submit">
                                                <icon-base viewBox="0 0 24 24"><icon-search /></icon-base>
                                            </button>
                                        </div>
                                    </form>

                                    <button class="collapse-btn ml-12" @click="checkAccordions ? closeAccordions() : openAccordions()" :disabled="!qualifications.length">
                                        <icon-base viewBox="0 0 14 8" class="collapse-btn__icon" :class="{'collapse-btn__icon_active': !checkAccordions}"><icon-arrow-top /></icon-base>
                                    </button>
                                </div>
                            </el-col>

                            <!-- <el-col :span="6" :offset="6" class="wizard-step-head__grow">
                                <div class="wizard-step-head__extra">
                                    <v-select class="select" placeholder="Группировка" :value="groupItemsBy.label" :clearable="false" :options="groupQualificationsOpts" :disabled="!groupQualification.length" @input="setItemsGroup">
                                        <template #no-options="{ search, searching, loading }">
                                            {{ SELECT_NOT_FOUND }}
                                        </template>
                                        <template #open-indicator="{ attributes }">
                                            <span v-bind="attributes">
                                                <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                                            </span>
                                        </template>
                                    </v-select>

                                    <button class="collapse-btn ml-12" @click="closeAccordions">
                                        <icon-base viewBox="0 0 14 8" class="collapse-btn__icon"><icon-arrow-top /></icon-base>
                                    </button>
                                </div>
                            </el-col> -->
                        </el-row>
                    </div>
                </div>
            </div>

            <div class="container">
                <accordion v-if="groupQualifications.length">
                    <accordion-item ref="accordionItem" active parent highlighted v-for="groupQualification in groupQualifications" :bus="bus" :key="groupQualification.groupId">
                        <template #accordion-head>
                            <div tabindex="0" class="accordion__head">
                                <div class="accordion__head-item">
                                    <p class="accordion__title" v-html="groupQualification.name"></p>
                                </div>

                                <div class="accordion__head-item">
                                    <icon-base viewBox="0 0 14 8" class="accordion__arrow">
                                        <icon-arrow-down />
                                    </icon-base>
                                </div>
                            </div>
                        </template>

                        <accordion class="mt-16">
                            <accordion-item :bus="bus" v-for="(qualification, index) in filteredItemsBySearch(groupQualification.items)" :key="qualification.kindId">
                                <template #accordion-head>
                                    <div class="accordion__head" tabindex="0">
                                        <div class="accordion__head-item" v-html="qualification.name"></div>

                                        <div class="accordion__head-item">
                                            <button v-if="!read" type="button" class="action-btn accordion__action" @click.stop="openQualificationsDialog(qualification.kindId)">
                                                <span class="action-btn__text">Создать или найти ПК</span>

                                                <span class="action-btn__helper">
                                                    <icon-base viewBox="0 0 12 12" class="action-btn__icon"><icon-action /></icon-base>
                                                </span>
                                            </button>

                                            <icon-base viewBox="0 0 14 8" class="accordion__arrow">
                                                <icon-arrow-down />
                                            </icon-base>
                                        </div>
                                    </div>
                                </template>

                                <el-table
                                    cell-class-name="table__cell"
                                    class="table table_top-scroll"
                                    header-cell-class-name="table__title"
                                    ref="table"
                                    row-key="id"
                                    :sort-orders="['ascending', 'descending']"
                                    :data="filteredInteriorItemsBySearch(qualification.items)"
                                >
                                    <el-table-column
                                        width="24"
                                        v-if="!read"
                                    >
                                        <template slot="header" slot-scope="scope">
                                            <div class="table_flex">
                                                <el-checkbox v-if="updateCheckboxAll" @change="toggleAllSelection(filteredInteriorItemsBySearch(qualification.items), qualification.kindId, $event)" :checked="selection[qualification.kindId] ? filteredInteriorItemsBySearch(qualification.items).length === selection[qualification.kindId].length : false" />
                                            </div>
                                        </template>
                                        <template slot-scope="scope">
                                            <div class="table_flex">
                                                <el-checkbox v-if="updateCheckbox" @change="handleSelectionChange([scope.row], qualification.kindId, $event)" :checked="handleSelectionValue([scope.row], qualification.kindId)" />
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        width="48"
                                    >
                                        <template slot="header" slot-scope="scope">
                                            <button type="button" class="settings-btn-main" @click="elDialogs.tableSettings = true">
                                                <icon-base viewBox="0 0 14 14" class="settings-btn__icon"><icon-settings-main /></icon-base>
                                            </button>
                                        </template>

                                        <template v-if="!read" slot-scope="scope">
                                            <selector-btn :options="accordionTableOptionsForBtn" :params="{ index: index, groupId: qualification.kindId, curId: scope.row.id }" portal="selectorModal" @clickOnItem="callback"></selector-btn>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        label="Код"
                                        prop="code"
                                        sortable
                                        min-width="100"
                                        v-if="qualificationsSettings.find((item) => item.name === 'code' && item.visible)"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        label="Название ПК"
                                        prop="name"
                                        sortable
                                        :min-width="400"
                                    >
                                        <template slot="header" slot-scope="scope">
                                            <span :forceUpdate="forceUpdate" v-if="!selection[qualification.kindId] || (selection[qualification.kindId] && !selection[qualification.kindId].length)">Название ПК</span>

                                            <button :forceUpdate="forceUpdate" type="button" class="btn btn_danger-second btn_small" v-if="selection[qualification.kindId] && selection[qualification.kindId].length" @click.stop="deleteItems({ index: index, groupId: qualification.kindId })">
                                                Удалить выбранные
                                            </button>
                                        </template>

                                        <template slot-scope="scope">
                                            <a href="#" v-html="scope.row.name" @click.prevent.stop="openQualification(scope.row.id)"></a>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        label="Уровень"
                                        prop="level"
                                        sortable
                                        min-width="100"
                                        v-if="qualificationsSettings.find((item) => item.name === 'level' && item.visible)"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        label="Название стандарта"
                                        prop="standard_name"
                                        sortable
                                        min-width="300"
                                        v-if="qualificationsSettings.find((item) => item.name === 'standard_name' && item.visible)"
                                    >
                                        <template slot-scope="scope">
                                            <span v-html="GET_KIND_BY_ID(scope.row.kind_id).standard_name"></span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column
                                        label="ТФ"
                                        prop="work_functions"
                                        sortable
                                        align="center"
                                        :width="50"
                                        v-if="qualificationsSettings.find((item) => item.name === 'work_functions' && item.visible)"
                                    >
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.hasOwnProperty('work_functions')" v-html="scope.row.work_functions ? scope.row.work_functions : 0"></span>
                                            <local-preloader v-else mini />
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        label="Труд. действия"
                                        prop="work_actions"
                                        sortable
                                        align="center"
                                        :width="130"
                                        v-if="qualificationsSettings.find((item) => item.name === 'work_actions' && item.visible)"
                                    >
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.hasOwnProperty('work_actions')" v-html="scope.row.work_actions ? scope.row.work_actions : 0"></span>
                                            <local-preloader v-else mini />
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        label="Умения"
                                        prop="work_skills"
                                        sortable
                                        align="center"
                                        :width="80"
                                        v-if="qualificationsSettings.find((item) => item.name === 'work_skills' && item.visible)"
                                    >
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.hasOwnProperty('work_skills')" v-html="scope.row.work_skills ? scope.row.work_skills : 0"></span>
                                            <local-preloader v-else mini />
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        label="Знания"
                                        prop="work_knowledges"
                                        sortable
                                        align="center"
                                        :width="80"
                                        v-if="qualificationsSettings.find((item) => item.name === 'work_knowledges' && item.visible)"
                                    >
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.hasOwnProperty('work_knowledges')" v-html="scope.row.work_knowledges ? scope.row.work_knowledges : 0"></span>
                                            <local-preloader v-else mini />
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        label="Обр. прог"
                                        prop="education_programs"
                                        sortable
                                        align="center"
                                        :width="90"
                                        v-if="qualificationsSettings.find((item) => item.name === 'education_programs' && item.visible)"
                                    >
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.hasOwnProperty('education_programs')" v-html="scope.row.education_programs ? scope.row.education_programs : 0"></span>
                                            <local-preloader v-else mini />
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        label="Статус"
                                        prop="status"
                                        sortable
                                        align="center"
                                        :width="200"
                                        v-if="qualificationsSettings.find((item) => item.name === 'status' && item.visible)"
                                    >
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.status_id" class="status" :class="{ [ STATUSES_DICT[scope.row.status_id].cls ]: true }">{{ STATUSES_DICT[scope.row.status_id].text }}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </accordion-item>
                        </accordion>
                    </accordion-item>
                </accordion>
            </div>
        </div>

        <reference-button v-if="hintsCode" :hasFooter="hasFooter" :hintsCode="hintsCode" :content="hints.content" />

        <!-- DIALOGS -->
        <qualifications-dialog :kindId="activeKindId" :qualificationsLoader="qualificationsLoader" />
        <table-settings-dialog :settings="qualificationsSettings" @saveTableSettings="changeTableColums" />

      <!-- PANELS -->
      <qualification-panel
          v-if="qualification"
          :read="read"
          :workFunctionsByQualificationLoader="workFunctionsByQualificationLoader"
          :programsByQualificationLoader="programsByQualificationLoader"
          :standartLoader="standartLoader"
      />
    </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import constants from '@/constants.js';
import step from '@/mixins/step';

import Accordion from '@/components/Accordion/Accordion';
import AccordionItem from '@/components/Accordion/AccordionItem';
import QualificationsDialog from '@/components/Dialogs/QualificationsDialog';
import TableSettingsDialog from '@/components/Dialogs/TableSettingsDialog';
import QualificationPanel from '@/components/WizardPanels/QualificationPanel';
import Tab from '@/components/Tabs/Tab';
import Tabs from '@/components/Tabs/Tabs';
import SelectorBtn from '@/components/SelectorBtn';
import LocalPreloader from '../LocalPreloader.vue';
import ReferenceButton from "../ReferenceButton";
import KindsDialog from "@/components/Dialogs/KindsDialog";
import AreasDialog from "@/components/Dialogs/AreasDialog";

export default {
    mixins: [ step ],
    components: {
        Accordion,
        AccordionItem,
        QualificationsDialog,
        QualificationPanel,
        TableSettingsDialog,
        Tab,
        Tabs,
        SelectorBtn,
        LocalPreloader,
        ReferenceButton,
        KindsDialog,
        AreasDialog
    },
    props: {
        read: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            bus: new Vue(),
            isMounted: false,
            forceUpdate: 1,
            updateCheckbox: true,
            updateCheckboxAll: true,

            activeKindId: null,

            searchValue: null,
            selection: {},

            qualificationsLoader: false,
            workFunctionsByQualificationLoader: false,
            programsByQualificationLoader: false,
            standartLoader: false,
            hasFooter: true,
            hintsCode: 'QualificationsStep',

            qualificationsSettings: [
                {
                    name: 'code',
                    title: 'Код',
                    visible: false,
                    default: false
                },
                {
                    name: 'name',
                    required: true,
                    title: 'Название',
                    visible: true,
                    default: true
                },
                {
                    name: 'level',
                    title: 'Уровень',
                    visible: false,
                    default: false
                },
                {
                    name: 'standard_name',
                    title: 'Название стандарта',
                    visible: false,
                    default: false
                },
                {
                    name: 'work_functions',
                    title: 'ТФ',
                    visible: true,
                    default: true
                },
                {
                    name: 'work_actions',
                    title: 'Труд. действия',
                    visible: true,
                    default: true
                },
                {
                    name: 'work_skills',
                    title: 'Умения',
                    visible: true,
                    default: true
                },
                {
                    name: 'work_knowledges',
                    title: 'Знания',
                    visible: true,
                    default: true
                },
                {
                    name: 'education_programs',
                    title: 'Обр.прог',
                    visible: true,
                    default: true
                },
                {
                    name: 'status',
                    title: 'Статус',
                    visible: false,
                    default: false
                },
            ],
            groupQualificationsOpts: [
                {
                    name: 'area_id',
                    label: 'По ОПД'
                },
                {
                    name: 'lifecycle_id',
                    label: 'По жизненному циклу'
                }
            ],
            accordionTableOptionsForBtn: [
                {
                    name: 'Удалить',
                    warning: true,
                    callback: 'deleteItems'
                }
            ]
        }
    },
    methods: {
        ...mapActions('editor', [
            'LOAD_STANDARD',
            'LOAD_QUALIFICATION',
            'SILENT_LOAD_WORK_FUNCTIONS_BY_QUALIFICATION',
            'SILENT_LOAD_PROGRAMS_BY_QUALIFICATION',
            'SILENT_LOAD_STANDARD',
            'DELETE_QUALIFICATIONS',
        ]),
        ...mapActions('listsForEditor', ['SILENT_LOAD_QUALIFICATIONS_LIST']),
        ...mapActions('hints', [
            'LOAD_HINTS',
        ]),
        ...mapActions('loader', ['show', 'hide']),
        ...mapMutations('common', [
            'TOGGLE_DIALOG',
            'TOGGLE_PANEL',
            'TOGGLE_SUCCESS_ALERT',
        ]),
        ...mapMutations('editor', ['GROUP_QUALIFICATIONS', 'SET_ITEMS_GROUP']),

        closeAccordions() {
            this.bus.$emit('closeAccordion');
        },
        openAccordions() {
            this.show()
            setTimeout(() => {
                this.bus.$emit('openAccordion');
                this.$nextTick(() => {
                    this.bus.$emit('openAccordion');
                    this.$nextTick(() => {
                        this.hide()
                    })
                })
            }, 0);
        },

        callback(emitObj) {
            this[emitObj.callback](emitObj.args)
        },
        changeTableColums(settings) {
            this.qualificationsSettings = settings
        },

        handleSelectionChange(val, parentId, event) {
            if (event) this.selection[parentId] = [...val, ...(this.selection[parentId] ? this.selection[parentId] : [])];
            else {
                this.selection[parentId] = this.selection[parentId].filter(select => !val.find(item => item.id === select.id))
                if (this.selection[parentId].length === 0) delete this.selection[parentId]
            }
            this.forceUpdate++
            this.forceRerenderCheckboxAll()
        },
        toggleAllSelection(val, parentId, event) {
            if (event) this.selection[parentId] = [...val];
            else delete this.selection[parentId]
            this.forceUpdate++
            this.forceRerenderCheckbox()
        },
        handleSelectionValue(val, parentId) {
            return this.selection[parentId] ? !!this.selection[parentId].filter(select => val.find(item => item.id === select.id)).length : false
        },
        forceRerenderCheckbox() {
            this.updateCheckbox = false;

            this.$nextTick(() => {
                this.updateCheckbox = true;
            });
        },
        forceRerenderCheckboxAll() {
            this.updateCheckboxAll = false;

            this.$nextTick(() => {
                this.updateCheckboxAll = true;
            });
        },

        setItemsGroup(value) {
            this.SET_ITEMS_GROUP(value);
            this.GROUP_QUALIFICATIONS(value.name);
        },

        filteredItemsBySearch(items) {
            return this.searchInput ? items.filter(item => item.items.filter(interiorItem => interiorItem.name.toLowerCase().includes(this.searchInput.toLowerCase())).length > 0) : items
        },
        filteredInteriorItemsBySearch(items) {
            const tempItems = [].concat(items)
            return this.searchInput ? tempItems.filter(item => item.name.toLowerCase().includes(this.searchInput.toLowerCase())) : tempItems
        },

        async deleteItems({ index, groupId, curId }) {
            if (curId) await this.DELETE_QUALIFICATIONS(curId);
            else await this.DELETE_QUALIFICATIONS(this.selection[groupId].map((item) => item.id));

            this.GROUP_QUALIFICATIONS(this.groupItemsBy.name);
            delete this.selection[groupId];
            this.forceUpdate++
        },

        async openQualification(id) {
            await this.LOAD_QUALIFICATION(id);

            this.elPanels.qualification = 1;

            this.workFunctionsByQualificationLoader = true
            this.programsByQualificationLoader = true
            this.standartLoader = true

            if (this.qualification.standard_id) {
              await this.loadStandart(this.qualification.standard_id);
            }
            if (!this.qualification.standard_id) {
              this.standartLoader = false;
            }

            await this.loadWorkFunctionsByQualification(id);
            await this.loadWorkProgramsByQualificationLoader(this.qualification.id);
        },
        async openQualificationsDialog(kindId) {
            console.log(kindId);
            this.activeKindId = kindId;

            if (this.qualificationsList.length === 0) {
                this.qualificationsLoader = true
                await this.loadAllQualifications()
            }
            this.elDialogs.qualifications = true;
        },

        async loadAllQualifications() {
            await this.SILENT_LOAD_QUALIFICATIONS_LIST();
            this.qualificationsLoader = false
        },
        async loadWorkFunctionsByQualification(id) {
            await this.SILENT_LOAD_WORK_FUNCTIONS_BY_QUALIFICATION(id),
            this.workFunctionsByQualificationLoader = false
        },
        async loadWorkProgramsByQualificationLoader(id) {
            await this.SILENT_LOAD_PROGRAMS_BY_QUALIFICATION(id),
            this.programsByQualificationLoader = false
        },
        async loadStandart(id) {
            await this.SILENT_LOAD_STANDARD(id),
            this.standartLoader = false
        },
    },
    computed: {
        ...mapGetters('common', ['IS_PANEL_OPEN']),
        ...mapGetters('editor', ['GET_KIND_BY_ID']),
        ...mapState('common', ['dialogs', 'panels']),
        ...mapState('editor', ['groupItemsBy', 'groupQualifications', 'qualification', 'qualifications']),
        ...mapState('listsForEditor', ['qualificationsList']),
        ...mapState('hints', ['hints']),

        checkAccordions() {
          console.log(this.isMounted);
            if (!this.groupQualifications.length) {return false;}
            if (!this.$refs.accordionItem && this.groupQualifications.length) {return true;}
            if (!this.isMounted) return false;
            else return this.$refs.accordionItem.map(el => el.isActive).includes(true);
        }
    },
    watch: {
        searchInput: function() {
            this.forceRerenderCheckboxAll()
        },

        'elPanels.qualification': function(val) {
            this.hasFooter = !val
            if (val === 1) this.hintsCode = 'QualificationsPanel'
            else if (val === 2) this.hintsCode = 'WorkFunctionsQualifications'
            else this.hintsCode = 'QualificationsStep'
        }
    },
    created() {
        this.SELECT_NOT_FOUND = constants.SELECT_NOT_FOUND;
        this.STATUSES_DICT = constants.STATUSES_DICT;
    },
    mounted() {
        this.isMounted = true;
    }
}
</script>
